import { Link } from "@inertiajs/react"

import { Button } from "@/components/ui/button"
import { BrandLockup } from "@/components/ui/brand-logo"
import { t } from "@/lib/i18n"

/**
 * The unauthenticated chrome for the staff sign-up screen.
 *
 * Deliberately the same shape as the landing header (wordmark left, sign-in
 * right): whoever lands here arrived by clicking "Crea tu restaurante" on
 * menny.app, and a page that swaps its chrome mid-funnel reads as a different
 * product. The sign-in link is the escape hatch for the person who already has
 * an account and clicked the wrong CTA.
 */
export function RegistrationHeader() {
  return (
    <header className="border-b">
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between gap-6 px-4 py-3">
        <BrandLockup />

        <Button variant="ghost" asChild>
          <Link href="/session/new" data-testid="staff-registration-sign-in">
            {t("ui.react.pages.staff.registrations.new.start_session")}
          </Link>
        </Button>
      </div>
    </header>
  )
}
